// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://thlpfhqjwrsjlvdrjqzk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRobHBmaHFqd3Jzamx2ZHJqcXprIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDcxODAyMjMsImV4cCI6MjA2Mjc1NjIyM30.0DAwZ_V7BMc-RHNOHjmI324l5QYZUjbOLrBsAuVqlKk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);